export type PlaceImageWithId = App.Image & { id: string }

export function mapPlaceImageIds(
  imageIds: Array<string> | undefined,
): Array<PlaceImageWithId> {
  return imageIds?.map((id) => ({ id })) ?? []
}

/**
 * Maps an array of image identifiers (LE CDN image IDs or legacy URLs) to App.Image objects.
 *
 * Prefers `imageIds` (new field from svc-trip) over `deprecatedImages` (legacy URL field).
 * Uses startsWith('http') to distinguish URLs from image IDs during the transition period.
 *
 * TODO(svc-trip PR 4 cleanup): once the deprecated `images`/`imageUrls` fields are removed
 * from the BE response, drop the `deprecatedImages` parameter and the URL branching.
 * This becomes a simple `imageIds.map((id) => ({ id }))` — same as mapImageIds in
 * HotelListingDrawer/mapToDrawerHotel.ts and ExperienceListingDrawer/mapExperienceDetailToDrawer.ts.
 */
export function mapPlaceImages(
  imageIds: Array<string> | undefined,
  deprecatedImages: Array<string> | undefined,
): Array<App.Image> {
  const source = imageIds ?? deprecatedImages
  if (!source) return []
  return source.map((val): App.Image =>
    val.startsWith('http') ? { url: val } : { id: val },
  )
}
